import { useEffect, useState } from "react";

const defaultTitleOptions = [
  { value: "Mr.", label: "Mr." },
  { value: "Mrs.", label: "Mrs." },
  { value: "Ms.", label: "Ms." },
  { value: "Miss.", label: "Miss." },
  { value: "Master.", label: "Master." },
  { value: "Dr.", label: "Dr." },
  { value: "Prof.", label: "Prof." },
  { value: "Baby of.", label: "Baby of." },
];

const InputName = ({
  name,
  value = "",
  onChange,
  placeholder,
  label,
  readOnly,
  required = false,
  setInputNameError,
  fieldName = "This field",
  minLengthMessage,

  // Title related props - optional
  showTitle = false,
  title = "",
  onTitleChange,
  titleOptions = defaultTitleOptions,
}) => {
  const [errMsg, setErrMsg] = useState("");

  const handleBlur = () => {
    const trimmedValue = value?.trim().replace(/\s+/g, " ");

    if (required && trimmedValue === "") {
      const requiredMessage = `${fieldName} is required.`;

      setErrMsg(requiredMessage);

      setInputNameError((previousState) => ({
        ...previousState,
        name: true,
      }));

      return;
    }

    if (trimmedValue && trimmedValue.length < 2) {
      const minLengthMessage =
        minLengthMessage ||
        `${fieldName} must be at least 2 characters long.`;

      setErrMsg(minLengthMessage);

      setInputNameError((previousState) => ({
        ...previousState,
        name: true,
      }));

      return;
    }

    onChange({
      target: {
        name,
        value: trimmedValue,
      },
    });

    setErrMsg("");

    setInputNameError((previousState) => ({
      ...previousState,
      name: false,
    }));
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;

    const hasNumber = /\d/.test(inputValue);

    if (hasNumber) {
      setErrMsg(`${fieldName} cannot contain numbers.`);

      setInputNameError((previousState) => ({
        ...previousState,
        name: true,
      }));
    } else {
      setErrMsg("");

      setInputNameError((previousState) => ({
        ...previousState,
        name: false,
      }));
    }

    inputValue = inputValue.replace(/[0-9]/g, "");
    inputValue = inputValue.replace(/\s+/g, " ");

    onChange({
      target: {
        name,
        value: inputValue,
      },
    });
  };

  useEffect(() => {
    if (!errMsg) {
      setInputNameError((previousState) => ({
        ...previousState,
        name: false,
      }));
    }
  }, [errMsg, setInputNameError]);

  return (
    <>
      <div className="form-group">
        <label htmlFor={name} className="col-form-label">
          {label}:
        </label>

        <div className="d-flex">
          {showTitle && (
            <select
              className="form-control"
              value={title}
              onChange={(e) =>
                onTitleChange?.({
                  target: {
                    name: "title",
                    value: e.target.value,
                  },
                })
              }
              disabled={readOnly}
              style={{
                width: "115px",
                minWidth: "115px",
                marginRight: "8px",
              }}
            >
              <option value="">--Title--</option>

              {titleOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}

          <input
            type="text"
            className="form-control"
            name={name}
            value={value}
            onChange={handleInputChange}
            onBlur={handleBlur}
            placeholder={placeholder}
            required={required}
            readOnly={readOnly || false}
          />
        </div>
      </div>

      {!readOnly && (
        <small className="text-danger">
          {errMsg}
        </small>
      )}
    </>
  );
};

export default InputName;